import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import MessageReducer from './MessageReducer';
import StoreReducer from './StoreReducer'
import MaintenanceReducer from "./MaintenanceReducer";
import ProjectReducer from "./ProjectReducer";
import ConfirmDialogReducer from "./ConfirmDialogReducer";
import ThemeReducer from "./ThemeReducer";
import FilterViewReducer from "./FilterViewReducer";
import ScannedProjectReducer from "./ScannedProjectReducer";
import BackgroundsReducer from "./BackgroundsReducer";

const AllReducers = combineReducers({ 
    auth: AuthReducer,
    message: MessageReducer,
    store: StoreReducer,
    maintenance: MaintenanceReducer,
    project: ProjectReducer,
    confirm: ConfirmDialogReducer,
    theme: ThemeReducer,
    filterView: FilterViewReducer,
    scannedProject: ScannedProjectReducer,
    backgrounds: BackgroundsReducer
});

export default AllReducers;